module.exports = "<div class=\"chronos\">\r\n  <hr>\r\n  <cron-editor [(cron)]=\"cronExpression\" [disabled]=\"isCronDisabled\" [(options)]=\"cronOptions\">Cron here...</cron-editor>\r\n  <!--<router-outlet></router-outlet>-->\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./app/insa-components/insa-cron/insa-cron-main/insa-cron.component.html
// module id = 1212
// module chunks = 2